import { css } from "@emotion/react";
import { bpoints } from "../../../../../Utils";

export function exitScreenCSS(){
    return css`
        background: #0C2036;
        flex-grow: 1;
        position: relative;
        z-index: 1;

        font-family: 'Neue Haas Grotesk Display Pro';
        font-style: normal;

        display: flex;
        justify-content: center;

        .bgLeftElement{
            
            left: 0;
            top: 12vh;

            width: calc(2rem + 10vw);
        }

        .bgRightElement{
            
            right: 0;
            bottom: 10vh;
        }

        .bgElement{
            position: absolute;

            @media (max-width: ${bpoints.mobile.w}px){
                display: none;
            }
        }

        .CenterDiv{
            margin-top: 8vh;
            display: flex;
            flex-direction: column;
            gap: 7vh;

            @media (max-width: ${bpoints.mobile.w}px){
                width: 85%;
            }

            .LogoDiv{
                display: flex;
                align-items: center;
                gap: 6vw;

                @media (max-width: ${bpoints.mobile.w}px){
                    gap: unset;
                    justify-content: space-between;
                }

                img{
                    width: calc(2.5rem + 6.5vw);
                    @media (max-width: ${bpoints.mobile.w}px){
                        width: calc(3.9rem + 12vw);
                    }
                }

                .Line{
                    width: 28vw;
                    height: 1.5px;
                    background: linear-gradient(90deg, rgba(32, 75, 123, 0.00) 0%, #204B7B 19.27%, #32B8DF 48.96%, #00BA6E 80.73%, rgba(0, 186, 110, 0.00) 98.44%);
                    
                    @media (max-width: ${bpoints.mobile.w}px){
                        width: 55%;
                        height: 1.8px;

                    }
                }
            }

            .BlueTextDiv{
                display: flex;
                flex-direction: column;

                color: #34C6F1;
            }


            .XLText{
                font-size: calc(1.5rem + 2.2vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(1.5rem + 4.9vw);
                }
            }

            .LText{
                font-size: calc(0.8rem + 2vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(0.8rem + 5.5vw);
                    padding: 0 0.3rem;
                }
            }

            .MText{
                font-size: calc(0.3rem + 1.6vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(0.7rem + 3.5vw);
                }

            }

            .GreenText{
                color: #1FDD8F;
            }

            .BottomTextDiv{
                color: #34C6F1;
                font-size: calc(0.2rem + 1.1vw);
                cursor: pointer;

                display: flex;
                gap: 1.5vw;

                @media (max-width: ${bpoints.mobile.w}px){
                    gap: 6vw;
                    font-size: calc(0.6rem + 2.5vw);
                    margin-top: 7vh;
                }

                img{
                    width: calc(0.5rem + 1.8vw);

                    @media (max-width: ${bpoints.mobile.w}px){
                        width: calc(1rem + 3vw);

                    }
                }

            }
        }
    `;
}